import React, { useContext, useEffect, useMemo } from 'react';
import { useUserManagement } from '../hooks/useUserManagement';

export const UserManagmentContext = React.createContext()

export const UserManagmentProvider = ({ children }) => {
    const userState = useUserManagement();
    const value = useMemo(() => userState, [userState])

    //useEffect(() => { console.log("UserProvider => ", value) }, [value])

    return (
        <UserManagmentContext.Provider value={value}>
            {children}
        </UserManagmentContext.Provider>
    );
}

export function useUserManagmentContext() {
    return useContext(UserManagmentContext)
}
